import { ReactNode } from 'react';
import ListyFilterBarDesktop from './ListyFilterBarDesktop';
import ListyFilterBarMobile from './ListyFilterBarMobile';

interface props {
  period: string;
  selected: string;
  totalItems: number;
  setPeriod: (period: string) => void;
  isXs: boolean;
  includeAllOrders?: boolean;
  query: string;
  setQuery: (query: string) => void;
  searchResetKey: number;
  children?: ReactNode;
}

export interface iProps extends props {
  sold: boolean;
  activeFilters: number;
}

const ListyFilterBar: React.FC<props> = (props) => {
  return props.isXs ? (
    <ListyFilterBarMobile
      period={props.period}
      selected={props.selected}
      setPeriod={props.setPeriod}
      includeAllOrders={props.includeAllOrders}
      query={props.query}
      setQuery={props.setQuery}
      searchResetKey={props.searchResetKey}
    >
      {props.children}
    </ListyFilterBarMobile>
  ) : (
    <ListyFilterBarDesktop
      period={props.period}
      selected={props.selected}
      setPeriod={props.setPeriod}
      totalItems={props.totalItems}
      includeAllOrders={props.includeAllOrders}
      query={props.query}
      setQuery={props.setQuery}
      searchResetKey={props.searchResetKey}
    >
      {props.children}
    </ListyFilterBarDesktop>
  );
};
export default ListyFilterBar;
